export enum ParcelPdfV2LotType {
	Built = "built",
	Agricultural = "agricultural",
	VacantOther = "vacantOther",
}

export enum ParcelPdfV2Metric {
	MunicipalAssessment = "municipalAssessment",
	Area = "area",
	Frontage = "frontage",
	Dwellings = "dwellings",
	LandValue = "landValue",
	SoilPotential = "soilPotential",
	AgriculturalZoneArea = "agriculturalZoneArea",
}

interface ParcelPdfV2Profile {
	metrics: readonly ParcelPdfV2Metric[]
	includeBuildingDetails: boolean
	includeServicedVacantLand: boolean
}

const profiles: Record<ParcelPdfV2LotType, ParcelPdfV2Profile> = {
	[ParcelPdfV2LotType.Built]: {
		metrics: [
			ParcelPdfV2Metric.MunicipalAssessment,
			ParcelPdfV2Metric.Area,
			ParcelPdfV2Metric.Frontage,
			ParcelPdfV2Metric.Dwellings,
		],
		includeBuildingDetails: true,
		includeServicedVacantLand: false,
	},
	[ParcelPdfV2LotType.Agricultural]: {
		metrics: [
			ParcelPdfV2Metric.Area,
			ParcelPdfV2Metric.LandValue,
			ParcelPdfV2Metric.SoilPotential,
			ParcelPdfV2Metric.AgriculturalZoneArea,
		],
		includeBuildingDetails: false,
		includeServicedVacantLand: true,
	},
	[ParcelPdfV2LotType.VacantOther]: {
		metrics: [ParcelPdfV2Metric.Area, ParcelPdfV2Metric.Frontage, ParcelPdfV2Metric.LandValue],
		includeBuildingDetails: false,
		includeServicedVacantLand: true,
	},
}

export function parcelPdfV2LotType(assetType: unknown, assetCategory: unknown): ParcelPdfV2LotType {
	if (assetType === "built") return ParcelPdfV2LotType.Built
	if (assetCategory === "LAND_AGR") return ParcelPdfV2LotType.Agricultural
	return ParcelPdfV2LotType.VacantOther
}

export function parcelPdfV2Profile(assetType: unknown, assetCategory: unknown): ParcelPdfV2Profile {
	return profiles[parcelPdfV2LotType(assetType, assetCategory)]
}
